<template>
    <div>
<v-dialog
      v-model="dialog"
      width="500"
    >
    
      <template v-slot:activator="{ on, attrs }">
        
        <v-btn
          v-bind="attrs"
          v-on="on"
          small
          outlined
          color="indigo darken-2"
        >
          <v-icon left small>mdi-clock-edit-outline</v-icon>
          Ajustar
        </v-btn>

      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Ajustar horário
        </v-card-title>

        <div >
           <v-form class="pa-5" ref="form">
            <v-text-field prepend-icon="mdi-clock-alert" label="Horário inicial" type="time" v-model="horaInit" >

            </v-text-field>
            <v-text-field prepend-icon="mdi-clock-alert" label="Horário final" type="time" v-model="horaFim" >

            </v-text-field>


           </v-form>
        </div>

        <v-divider></v-divider>
      
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn  color="primary" text @click="dialog = false">
            Fechar
          </v-btn>
          <v-btn  color="primary" text :loading="salvando" :disabled="salvando" @click="atualizarItem">
            Atualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>

import { ajustarAgendamentoNoPortal } from '@/services/agendaFirestore'

    export default {
        props: ['itemPassado'],
        data(){
            return {
                dialog: false,
                horaInit: '',
                horaFim: '',
                salvando: false,
            }
        },
        created(){
        this.metodoInit()
        },
        methods: {
            metodoInit(){
                console.log(this.itemPassado);
                this.horaInit = this.itemPassado.start.split(" ")[1]
                this.horaFim = this.itemPassado.end.split(" ")[1]
                console.log(this.horaInit);
                console.log(this.horaFim);
            },
            async atualizarItem(){
                if(this.salvando){
                    return
                }
                this.salvando = true
                try {
                    await ajustarAgendamentoNoPortal(
                        this.itemPassado,
                        this.horaInit,
                        this.horaFim
                    )
                    this.$emit('attAgenda');
                    this.dialog = false
                } catch (error) {
                    this.$toasted.global.defaultError({ msg: error.message })
                } finally {
                    this.salvando = false
                }
            }
        }

    }
</script>

<style lang="scss" scoped>

</style>
